// Proposed DIJ changes from the chat agent. Statuses come from the backend
// (actionResult, or actionResults for Apply all); a card can also expire.
export const FINAL_STATES = [
  'applied',
  'cancelled',
  'failed',
  'conflict',
  'expired',
  'unavailable',
  'refused',
];

// Whether a card can still be applied: not handled yet and not expired.
export function isApplicable(action, nowMs = Date.now()) {
  if (FINAL_STATES.includes(action.status)) return false;
  return !(action.expiresAt && nowMs / 1000 >= action.expiresAt);
}
